/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$(document).ready(function() {
  if(jQuery("#shopify-chat").length > 0){
    setTimeout(function () {
      var mainChat = jQuery("#shopify-chat").find('#ShopifyChat');
      var elmShadowRoot = mainChat[0].shadowRoot;
      var chatApp = jQuery(elmShadowRoot).find(".chat-app");
      var styleApp = jQuery(elmShadowRoot).find("style");
      var css = '<style type="text/css">' +
              'button.chat-toggle.chat-toggle--text-button .chat-title{display:none!important;} ' +
              '.chat-toggle svg{opacity:0;} ' +
              '.chat-app--is-mobile{margin-bottom:-70px;}' +
              'button.chat-toggle{margin-right:10px;border-radius:50%!important;height:56px!important;}' +
              'button.chat-toggle.chat-toggle--text-button{padding: 0 .25rem 0 .25rem !important;} ' +
              '.chat-label{pointer-events:none;position:absolute;top:50%;transform:translateY(-50%);color:#1e2433;background-color:#fff;border-radius:8px;padding:10px 15px;white-space:nowrap;margin:0 15px;font-size:14px;line-height:1.2;box-shadow:0 6px 6px #00122e3d;transition:margin .2s cubic-bezier(.4,.22,.28,1),opacity 80ms,visibility 80ms;transition-delay:.2s;right:65px} ' +
              '@media only screen and (max-width: 749px){button.chat-toggle{width:46px!important;height:46px!important;margin-right:3px!important;} .chat-label{font-size:12px;padding:6px 12px;margin: 0 10px;right:50px!important;transform:translateY(-80%)!important;} .img-label{width:28px!important;top:5px!important;left:10px!important;}}' +
              '</style>';
      var chatAppLabel = '<div class="chat-label">Tracking order</div>';
      var buttonChatIcon = '<img class="img-label" src="https://cdn.shopify.com/s/files/1/0700/5437/9804/files/package-white_512x_858e220b-d029-4587-ae60-d2c3dc996f15.png?v=1704347003" style="width: 35px; padding: 5px; position: absolute; top: 7px; left: 11px;">';
      jQuery(chatApp).prepend(chatAppLabel);
      jQuery(elmShadowRoot).prepend(css);
      jQuery(chatApp).prepend(buttonChatIcon);
    }, 700)
  }
  
  if ($("div#voucher-wrapper").length > 0) {
    let getIdGroup = $('#voucher-wrapper').attr('group');
    let getIdCustomer = $('.get-customer-information').attr('customer-id');
    let currentUrl = window.location.href;
    let getUrlStore = $('#voucher-wrapper').attr('url-shopify');
    let titlePage =  $('.get-customer-information').attr('page-title');
    
    $.ajax({
      type: "POST",
      url: "https://atmos-custom-plugin.devbdd.com/front/display_list_voucher",
      data: { id:getIdGroup,customerId:getIdCustomer,currentUrl:currentUrl,url_shopify:getUrlStore,titlePage:titlePage },
      success: function(response){
        $('#voucher-wrapper').append(response)
        if(currentUrl.includes('claim=failed')){
          $('#voucher-wrapper').prepend('<div class="voucher-wrappe-failed">Claim voucher failed, please <a href="/account/login">login here.</a></div>');
        }
  
        let content_mystery_box = `
          <div class="open-voucher-wrapper">
            <div class="open-voucher-content">
              <div class="wrapper open-voucher-here">
                <div class="lid one"></div>
                <div class="lid two"></div>
                <div class="envelope"></div>
                <div class="letter">
                  <p></p>
                  <span></span>
                  <small></small>
                </div>
              </div>
  
              <button class="main-button button-open-voucher">GET EID MUBARAK VOUCHER</button>
              <div class="msg-res"></div>
            </div>
          </div>
        `;
      }
    });
  }
  if ($('.upcoming-mobile').length) {
    $('#appendUpcomingProduct').append($('.upcoming-mobile'));
    $('.upcoming-mobile').attr('style', '');
  }
  $('.raffle-carousel').flickity({
    prevNextButtons: true,
    autoPlay: 2000,
    adaptiveHeight: true,
    watchCSS: true,
    dragThreshold: 8,
    arrowShape: {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25},
    draggable: false
  });

  $('[data-drawer-id="sidebar-menu"]').click(function (e) {
    if ($('#sidebar-menu').attr('aria-hidden') == 'true') {
      $('.CollectionWrapper .CollectionFilter.filter-sticky').css('z-index', '1');
      $('[data-section-type="collection"] .PageHeader').css('z-index', '1');
    }
  })

  $('[data-section-id="sidebar-menu"] .Drawer__Close').click(function (e) {
    if ($('#sidebar-menu').attr('aria-hidden') == 'false') {
      $('.CollectionWrapper .CollectionFilter.filter-sticky').css('z-index', '');
      $('[data-section-type="collection"] .PageHeader').css('z-index', '');
    }
  })

  // upcoming product main js
  if ($('body').hasClass('template-upcoming')) {
    $('.upcoming-carousel').owlCarousel({
      items: 1,
      loop: true,
      nav: true,
      navText: [
        "<div class='nav-btn prev-slide'></div>",
        "<div class='nav-btn next-slide'></div>",
      ]
    });
    $(document).on('click', '#openForm', function (e) {
      e.preventDefault();
      $('body').css('overflow', 'hidden');
      $('.popup-form').show();
      $('.upcoming-floating').addClass('hidefloating');
    })
    
    $(document).on('click', '.form-close .close', function (e) {
      e.preventDefault();
      $('body').css('overflow', '');
      $('.popup-form').hide();
      $('.upcoming-floating').removeClass('hidefloating');
    })
    
    $('#enterForm').on('click', function (e) {
      e.preventDefault(); 
      console.log(e);
      $('body').css('overflow', 'hidden');
      $('.popup-form').show();
      $('.upcoming-floating').addClass('hidefloating');
    })
    
    function showFloatingDraw() {
      const floatingElement = document.querySelector(".upcoming-floating");
      if (window.scrollY > 300) {
        floatingElement.style.transform = "translateY(0)";
      } else {
        floatingElement.style.transform = "";
      }
    }
    
    window.addEventListener("scroll", showFloatingDraw);
    window.addEventListener("load", showFloatingDraw);
    
    $('.form-product-register').on('submit', function (e) {
      e.preventDefault();
      let url = 'https://atmos-custom-plugin-front.devbdd.com/api/customers/submit'
      let name = $("[name=name]").val() ? $("[name=name]").val() : "";
      let email = $("[name=email]").val() ? $("[name=email]").val() : "";
      let phone = $("[name=phone]").val() ? $("[name=phone]").val() : "";
      let product_id = $('#product_id').val();
    
      let jsonData = {
        "url_shopify": Shopify.shop,
        "id_form": 2,
        "ktp": 0,
        "receipt_number": 0,
        "product_id": product_id,
        "name" : name,
        "email" : email,
        "phone" : phone,
        "ig" : null,
        "shoe_size" : null,
        "address" :null,
        "birtday" : null
      }
    
      console.log(jsonData);
    
      $.ajax({
        url: "https://atmos-custom-plugin-front.devbdd.com/api/customers/submit",
        type: 'POST',
        data: jsonData, // Include data in the request
        dataType: 'json',
        crossDomain: true, // Enable CORS
        beforeSend: function (){
            $(".form-content-submit .form-submit").html(`Loading...`).attr("disabled", "disabled")
        },
        success: function(data) {
          $(".form-content-submit .form-submit").html(`Submit`).removeAttr("disabled")
            let result = data.response;
            
            if(result['status'] == "200"){
                // alert("Successfully submitted");
                $(".form-response").html("Thankyou for your submit.").css("text-align", "center")
                // location.reload();
            }
            else{
                alert("Already submitted");
            }
        },
        error: function(xhr, status, error) {
            console.log(error, xhr, status)
        }
      });
    })
    
  }
  var acc = document.getElementsByClassName("filter-accordion");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("filter-active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = "250px";
      } 
    });
  }
  if ($(window).width() < 700) {
    $('.PageHeader__ImageWrapper').css({
      'transform': 'none !important'
    })  
  }

  var announce_height = $('#shopify-section-announcement').outerHeight();
  var header_height = $('#shopify-section-header').outerHeight();
  var headerc_height = $('.PageHeader').outerHeight();

  var hasil_gabungan = announce_height + headerc_height;
  var window_height = $(window).height();

  var hasil_final = window_height - header_height;
  var hasil_mobile_lebih = header_height + headerc_height;
  var hasil_mobile_kurang = announce_height + header_height + headerc_height;

  $('.filter-sticky .panel').css('top', hasil_mobile_kurang + 'px');

  $(window).scroll(function () {
    if ($(this).scrollTop() > hasil_gabungan) {
      $('.filter-sticky').addClass('is-sticky')
      $('.filter-sticky.is-sticky').css('max-height', hasil_final + 'px');
      $('.filter-sticky.is-sticky').css('top', header_height + 'px');
    } else {
      $('.filter-sticky').removeClass('is-sticky')
      $('.filter-sticky').css('max-height', 'inherit');
    }

    if ($(this).scrollTop() > announce_height) {
      $('.filter-sticky .panel').css('top', hasil_mobile_lebih + 'px');
    } else {
      $('.filter-sticky .panel').css('top', hasil_mobile_kurang + 'px');
    }
  })

  if ($('.filter-form').length) {
    let input = $('.filter-form').find('input')
    $.each(input, function (i, v) {
      $(v).change(function () {
        // console.log($(v))
        $('.filter-form').trigger('submit')
      })
    })
  }
  
  if ($('.filter-group-size label')) {
    let checkSize = $('.filter-group-Size label input')
    $.each(checkSize, function (i, v) {
      if ($(v).is(":checked")) {
        $(v).parent('label').addClass('active')
      }
      else {
        $(v).parent('label').removeClass('active')
      }
    })
  
    $(checkSize).change(function () {
      if ($(this).is(":checked")) {
        $(this).parent('label').addClass('active')
      }
      else {
        $(this).parent('label').removeClass('active')
      }
    })
  }

  if (window.location.search) {
    const urlParams = new URLSearchParams(window.location.search);
    const filter_tag = urlParams.get('filter.p.tag')
    const filter_all = urlParams.getAll('filter.p.tag')
  
    if ($('input[name="filter.p.tag"]').length) {
      $.each($('input[name="filter.p.tag"]'), function (i, v) {
        if (filter_all.indexOf($(v).val()) !== -1) {
          $(v).parent('label').addClass('active')
          $(v).attr('checked', true)
        }
      })
    }
  
    const filter_size = urlParams.get('filter.v.option.size')
    const filter_size_all = urlParams.getAll('filter.v.option.size')
  
    if ($('input[name="filter.v.option.size"]').length) {
      $.each($('input[name="filter.v.option.size"]'), function (i, v) {
        console.log('option.size', $(v))
  
        if (filter_size_all.indexOf($(v).val()) !== -1) {
          $(v).parent('label').addClass('active')
          $(v).attr('checked', true)
        }
      })
    }
  }
  $('.filter-toggle').click(function (e) {
    let $this = $(this);
    if ($this.attr('aria-open') == 'false') {
      console.log('opened')
      $this.attr('aria-open', 'true')
      $('.filter-sticky').removeClass('hidden-phone');
    } else if ($this.attr('aria-open') == 'true') {
      console.log('closed')
      $this.attr('aria-open', 'false')
      $('.filter-sticky').toggleClass('hidden-phone');
    }
  })
  var url = window.location.href;
  var is_product = url.match(/.*\/products\/.*/);
  if (window.location.href.includes('collections')) {
    if (is_product == null) {
      document.querySelector('#SortBy').addEventListener('change', function () {
        const urlSearchParams = new URLSearchParams(window.location.search);
        urlSearchParams.set(this.name, this.value);
        window.location = `?${urlSearchParams}`;
      })
    }
  }
  
  if($(".brand-list-wrapper").length){
    $(window).scroll(function() {
      // Mendapatkan posisi scroll
      var scrollPosition = $(window).scrollTop();

      // Mendapatkan posisi elemen target
      var targetElementPosition = $(".brand-list-target").offset().top + 100;

      // Menetapkan pesan status
      if (scrollPosition > targetElementPosition) {
        if(!$(".brand-list-wrapper").hasClass("show")){
          $(".brand-list-wrapper").addClass("show")
        }
      } else {
        if($(".brand-list-wrapper").hasClass("show")){
          $(".brand-list-wrapper").removeClass("show")
        }
      }
    });
  }

})